// extracted by mini-css-extract-plugin
export default {"container":"newCardsGroup_container__x+Fo5"};